import Loader from "../../ui/Loader";

export const getCardLabel = (key) => {
  switch (key) {
    case "total":
      return "Total Recurring Subscriptions";
    case "total_completed":
      return "Recurring Subscription Purchased";
    case "total_pending":
      return "Recurring Subscription Not Purchased";
    case "total_added_to_lead":
      return "Added to LMS";
    case "total_not_added_to_lead":
      return "Not Added to LMS";
    default:
      return key.replace(/_/g, " ");
  }
};
